<main class="main">
    <p-toast key="default" position="bottom-left"></p-toast>
    <p-toast key="masquerade" position="bottom-right"></p-toast>
    <router-outlet></router-outlet>
</main>
